import { pgTable, unique, uuid, text, foreignKey, jsonb, integer, boolean, } from 'drizzle-orm/pg-core';
import { orgTableBase, orgPrimaryKey } from '../org-id';
import { relations } from 'drizzle-orm';
import { Team } from '../roster/team';
import { Block } from '.';
/**
 * The single "currently selected workout for display" per team.
 *
 * Row exists = active selection. Stopping a display DELETES the row
 */
export const TeamDisplaySelection = pgTable('team_display_selection', {
    ...orgTableBase,
    teamId: uuid('team_id').notNull(),
    blockId: uuid('block_id').notNull(),
    workoutId: uuid('workout_id').notNull(),
    sectionIds: jsonb('section_ids').$type().notNull().default([]),
    quote: text('quote'),
    pageDurationSeconds: integer('page_duration_seconds'),
    highlightSupersets: boolean('highlight_supersets').notNull().default(true),
}, (table) => ({
    pk: orgPrimaryKey(table),
    orgTeamUq: unique().on(table.orgId, table.teamId),
    teamFk: foreignKey({
        columns: [table.orgId, table.teamId],
        foreignColumns: [Team.orgId, Team.id],
    }),
    blockFk: foreignKey({
        columns: [table.orgId, table.blockId],
        foreignColumns: [Block.orgId, Block.id],
    }),
}));
export const TeamDisplaySelection_Relations = relations(TeamDisplaySelection, ({ one }) => ({
    team: one(Team, {
        fields: [TeamDisplaySelection.orgId, TeamDisplaySelection.teamId],
        references: [Team.orgId, Team.id],
    }),
    block: one(Block, {
        fields: [TeamDisplaySelection.orgId, TeamDisplaySelection.blockId],
        references: [Block.orgId, Block.id],
    }),
}));
//# sourceMappingURL=team-display-selection.js.map